import type {
  ExchangeRate,
  PutPlatformV1OpsExchangeRatesBody,
} from '@nucleus-commerce/api-client/platform';

import type { RateRowInput, RateRowsOutput } from '../schemas/rate-rows-schema';

export function toPutRatesRequest(values: RateRowsOutput): PutPlatformV1OpsExchangeRatesBody {
  return {
    rates: values.rates.map((row) => ({
      baseCurrency: row.baseCurrency,
      quoteCurrency: row.quoteCurrency,
      rate: Number(row.rate),
    })),
  };
}

export function rowFromRate(rate: ExchangeRate): RateRowInput {
  return {
    baseCurrency: rate.baseCurrency,
    quoteCurrency: rate.quoteCurrency,
    rate: String(rate.rate),
  };
}

export function pairLabel(rate: Pick<ExchangeRate, 'baseCurrency' | 'quoteCurrency'>): string {
  return `${rate.baseCurrency} → ${rate.quoteCurrency}`;
}
